import { render, staticRenderFns } from "./JiaoBiao.vue?vue&type=template&id=bf3af632"
import script from "./JiaoBiao.vue?vue&type=script&lang=js"
export * from "./JiaoBiao.vue?vue&type=script&lang=js"
import style0 from "./JiaoBiao.vue?vue&type=style&index=0&id=bf3af632&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports